import { render } from "./attributePage.vue?vue&type=template&id=1717ed32&scoped=true"
import script from "./attributePage.vue?vue&type=script&lang=js"
export * from "./attributePage.vue?vue&type=script&lang=js"

import "./attributePage.vue?vue&type=style&index=0&id=1717ed32&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4154090898/src/platform-insurance-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1717ed32"]])

export default __exports__